const css = `.ctnDoa__map{background-color:var(--base-surfaces-default);background-image:url(/s/img/map_placeholder.png);background-repeat:no-repeat;background-size:cover}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"map":"ctnDoa__map"};
